import React from 'react';
import { formatTipoPeriodoLabel } from './workflow-periodicidad';

export interface PeriodoTipoResumen {
  tipo: string;
  tipoLabel?: string;
  cantidad: number;
  porcentaje?: number;
}

const RESUMEN_TIPOS_REQUERIDOS = ['MENSUAL', 'SEMESTRAL', 'ANUAL'];

export function normalizeTipoResumenRows(rows: PeriodoTipoResumen[]): PeriodoTipoResumen[] {
  const byTipo = new Map(
    rows.map(row => [String(row.tipo).toUpperCase(), row]),
  );
  return RESUMEN_TIPOS_REQUERIDOS.map(tipo => {
    const existing = byTipo.get(tipo);
    return {
      tipo,
      tipoLabel: existing?.tipoLabel ?? formatTipoPeriodoLabel(tipo),
      cantidad: Number(existing?.cantidad) || 0,
      porcentaje: existing?.porcentaje,
    };
  });
}

export default function PeriodoTipoResumenBar({
  rows,
  loading,
  onTipoClick,
  subtitle,
  filterHint = 'tipo',
}: {
  rows: PeriodoTipoResumen[];
  loading: boolean;
  onTipoClick: (tipo: string) => void;
  subtitle?: string;
  filterHint?: string;
}) {
  const total = rows.reduce((sum, row) => sum + (Number(row.cantidad) || 0), 0);
  const displayRows = normalizeTipoResumenRows(rows);

  if (loading) {
    return (
      <div className="procesos-estado-resumen" role="status" aria-live="polite">
        <span className="procesos-estado-resumen__loading">
          Cargando resumen{subtitle ? ` ${subtitle.toLowerCase()}` : ' por tipo'}…
        </span>
      </div>
    );
  }

  return (
    <div className="procesos-estado-resumen" role="status" aria-live="polite" aria-label={subtitle ?? 'Resumen por tipo'}>
      {displayRows.map(row => {
        const cantidad = Number(row.cantidad) || 0;
        const pct = row.porcentaje != null
          ? Math.round(row.porcentaje)
          : total > 0
            ? Math.round((cantidad / total) * 100)
            : null;
        const label = row.tipoLabel ?? formatTipoPeriodoLabel(row.tipo);

        return (
          <button
            key={row.tipo}
            type="button"
            className="procesos-estado-resumen__estado procesos-estado-resumen__estado-filter"
            onClick={() => onTipoClick(row.tipo)}
            title={`Filtrar por ${filterHint}: ${label}`}
            aria-label={`Filtrar por ${filterHint} ${label}`}
          >
            <span className="procesos-estado-resumen__estado-label">{label}</span>
            <div className="procesos-estado-resumen__metricas">
              <span className="procesos-estado-resumen__valor">{cantidad}</span>
              <span className="procesos-estado-resumen__valor">
                {pct == null ? 'N/D' : `${pct}%`}
              </span>
            </div>
          </button>
        );
      })}
      <div className="procesos-estado-resumen__total">
        <span className="procesos-estado-resumen__total-label">Total</span>
        <span className="procesos-estado-resumen__valor procesos-estado-resumen__valor--total">{total}</span>
      </div>
    </div>
  );
}
